








































import Vue from "vue";
import store, { RoleStore } from "@/modules/roles/services/roleStore";
import DeniedRelation from "../models/DeniedRelation";
import { t } from "@/plugins/i18n";

interface Data {
  store: RoleStore;
}

export default Vue.extend<Data, {}, {}, {}>({
  data: () => ({
    store,
  }),

  async beforeMount() {
    await this.store.loadUsers();
    await this.store.loadDeniedRelations();
  },

  methods: {
    async save(relation: DeniedRelation) {
      await this.store.saveDeniedRelations(relation);
    },
  },

  computed: {
    columns: () => [
      { field: "feature", title: t("Roles_Funkcio") },
      { field: "users", title: t("Roles_Felhasznalok"), cell: "userTemplate" },
    ],
  },
});
